import { Pipe, PipeTransform } from '@angular/core';

/**
 * Returns
 * - the first occurence of an element in an Array if not empty,
 * - the first element and ,... if more than one elements exist
 * - null if no or only empty elements are present
 */
@Pipe({
  name: 'arrayAbbreviate'
})
export class ArrayAbbreviatePipe implements PipeTransform {
  /**
   * @param {Array<any>} values
   * @param {string} abrevMarker    E.g. '...'
   * @param {number} cutoff    Number after which the array will be abbreviated, e.g. '1'
   * @param valueAccessorFunction   Use this if value contains a property which shall be displayed. Otherwise use x => return x;
   * @returns {string}              E.g. 'Wohnrecht,...'
   */
  transform(values: Array<any>, abrevMarker: string, cutoff: number, valueAccessorFunction): string {
    if (!values || values.length === 0 || !values[0] || cutoff == 0) {
      return '';
    }
    let arrayValues = valueAccessorFunction(values[0]);
    if (cutoff > 1) {
      for (let i = 1; i < values.length && i < cutoff; i++) {
        arrayValues += ', ';
        arrayValues += valueAccessorFunction(values[i]);
      }
    }
    if (arrayValues) {
      return values.length > cutoff ? arrayValues + ',' + abrevMarker : arrayValues;
    }
    return '';
  }
}
